module.exports = __webpack_public_path__ + "media/images/athletes/4154-c4123945af8152943b78ac4ae6ca91f6.png";